import { render, staticRenderFns } from "./view-customer-type.vue?vue&type=template&id=1997e46c&"
import script from "./view-customer-type.vue?vue&type=script&lang=ts&"
export * from "./view-customer-type.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports